export default "__VITE_ASSET__CVyoZ1nx__"